export const checkIsTeamAssignee = option => option.isTeam;
export const checkIsUserAssignee = option => Boolean(option.responder);